export default __webpack_public_path__ + "static/media/twitter-1460983933454143494.16a3d1c7.jpg";